<div class="popup-container">
    <div class="popup-model">
        <div class="popup-header">
            <div class="popup-header-text">{{headerTitle}}</div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
            <div class="message-block">
                {{messageText}}
            </div>
        </div>
        <div class="popup-footer">
            <div class="popup-btn" (click)="confirm()">
                <!-- <div class="btn-icon check-circle-icon"></div> -->
                <div class="btn-text">{{confirmBtnText}}</div>
            </div>
            <div class="popup-btn" (click)="cancel()">
                <!-- <div class="btn-icon cancel-circle-icon"></div> -->
                <div class="btn-text">{{cancelBtnText}}</div>
            </div>
        </div>
    </div>
</div>